(function () {
(()=>{
    // Dictionary to map Zephr COUNTRY values to DIGIOH COUNTRY values
    window.ZEPHR_COUNTRY_VALUE_DICTIONARY = {
        USA: "United States",
        CAN: "Canada",
        MEX: "Mexico",
        AFG: "Afghanistan",
        ALB: "Albania",
        DZA: "Algeria",
        AND: "Andorra",
        AGO: "Angola",
        AIA: "Anguilla",
        ATG: "Antigua and Barbuda",
        ARG: "Argentina",
        ARM: "Armenia",
        ABW: "Aruba",
        SHN: "Ascension",
        AUS: "Australia",
        AUT: "Austria",
        AZE: "Azerbaijan",
        BHS: "Bahamas",
        BHR: "Bahrain",
        BGD: "Bangladesh",
        BRB: "Barbados",
        BLR: "Belarus",
        BEL: "Belgium",
        BLZ: "Belize",
        BEN: "Benin",
        BMU: "Bermuda",
        BTN: "Bhutan",
        BOL: "Bolivia",
        BIH: "Bosnia-Herzegovina",
        BWA: "Botswana",
        BRA: "Brazil",
        VGB: "British Virgin Islands",
        BRN: "Brunei",
        BGR: "Bulgaria",
        BFA: "Burkina Faso",
        BUR: "Burma",
        BDI: "Burundi",
        KHM: "Cambodia",
        CMR: "Cameroon",
        CPV: "Cape Verde",
        CYM: "Cayman Islands",
        CAF: "Central African Republic",
        TCD: "Chad",
        CHL: "Chile",
        CHN: "China",
        COL: "Colombia",
        COM: "Comoros",
        COD: "Congo",
        COK: "Cook Island",
        CRI: "Costa Rica",
        HRV: "Croatia",
        CUB: "Cuba",
        CYP: "Cyprus",
        CZE: "Czech Republic",
        DNK: "Denmark",
        DJI: "Djibouti",
        DMA: "Dominica",
        DOM: "Dominican Republic",
        ECU: "Ecuador",
        EGY: "Egypt",
        SLV: "El Salvador",
        GNQ: "Equatorial Guinea",
        ERI: "Eritrea",
        EST: "Estonia",
        ETH: "Ethiopia",
        FRO: "Faroe Islands",
        FJI: "Fiji Islands",
        FIN: "Finland",
        FRA: "France",
        GUF: "French Guiana",
        PYF: "French Polynesia",
        GAB: "Gabon",
        GMB: "Gambia",
        GEO: "Georgia",
        DEU: "Germany",
        GHA: "Ghana",
        GIB: "Gibraltar",
        GRC: "Greece",
        GRL: "Greenland",
        GRD: "Grenada",
        GLP: "Guadeloupe",
        GTM: "Guatemala",
        GIN: "Guinea",
        GNB: "Guinea-Bissau",
        GUY: "Guyana",
        HTI: "Haiti",
        HND: "Honduras",
        HKG: "Hong Kong",
        HUN: "Hungary",
        ISL: "Iceland",
        IND: "India",
        IDN: "Indonesia",
        IRN: "Iran",
        IRQ: "Iraq",
        IRL: "Ireland",
        IMN: "Isle Of Man",
        ISR: "Israel",
        ITA: "Italy",
        CIV: "Ivory Coast",
        JAM: "Jamaica",
        JPN: "Japan",
        JOR: "Jordan",
        KAZ: "Kazakhstan",
        KEN: "Kenya",
        KIR: "Kiribati",
        UNK: "Kosovo",
        KWT: "Kuwait",
        KGZ: "Kyrgyzstan",
        LAO: "Laos",
        LVA: "Latvia",
        LBN: "Lebanon",
        LSO: "Lesotho",
        LBR: "Liberia",
        LBY: "Libya",
        LIE: "Liechtenstein",
        LTU: "Lithuania",
        LUX: "Luxembourg",
        MAC: "Macao",
        MKD: "Macedonia",
        MDG: "Madagascar",
        MWI: "Malawi",
        MYS: "Malaysia",
        MDV: "Maldives",
        MLI: "Mali",
        MLT: "Malta",
        MHL: "Marshall Islands",
        MTQ: "Martinique",
        MRT: "Mauritania",
        MUS: "Mauritius",
        MDA: "Moldova",
        MCO: "Monaco",
        MNG: "Mongolia",
        MSR: "Monserrat",
        MNE: "Montenegro",
        MAR: "Morocco",
        MOZ: "Mozambique",
        MMR: "Myanmar",
        NAM: "Namibia",
        NRU: "Nauru",
        NPL: "Nepal",
        NLD: "Netherlands",
        ANT: "Netherlands Antilles",
        NCL: "New Caledonia",
        NZL: "New Zealand",
        NIC: "Nicaragua",
        NER: "Niger",
        NGA: "Nigeria",
        NOR: "Norway",
        OMN: "Oman",
        PAK: "Pakistan",
        PLW: "Palau",
        PSE: "Palestine",
        PAN: "Panama",
        PNG: "Papua New Guinea",
        PRY: "Paraguay",
        PER: "Peru",
        PHL: "Philippines",
        PCN: "Pitcairn Is",
        POL: "Poland",
        PRT: "Portugal",
        QAT: "Qatar",
        REU: "Reunion",
        ROU: "Romania",
        RUS: "Russia",
        RWA: "Rwanda",
        SMR: "San Marino",
        STP: "Sao Tome & Principe",
        SAU: "Saudi Arabia",
        SEN: "Senegal",
        SRB: "Serbia",
        SYC: "Seychelles",
        SLE: "Sierra Leone",
        SGP: "Singapore",
        SVK: "Slovakia",
        SVN: "Slovenia",
        SLB: "Solomon Islands",
        SOM: "Somalia",
        ZAF: "South Africa",
        KOR: "South Korea",
        ESP: "Spain",
        LKA: "Sri Lanka",
        KNA: "St Kitts",
        LCA: "St Lucia",
        MAF: "St Martin",
        SPM: "St Pierre",
        VCT: "St Vincent And The Grenadines",
        SDN: "Sudan",
        SUR: "Suriname",
        SWZ: "Swaziland",
        SWE: "Sweden",
        CHE: "Switzerland",
        SYR: "Syria",
        TWN: "Taiwan",
        TJK: "Tajikistan",
        TZA: "Tanzania",
        THA: "Thailand",
        TGO: "Togo",
        TON: "Tonga",
        TTO: "Trinidad & Tobago",
        TUN: "Tunisia",
        TUR: "Turkey",
        TKM: "Turkmenistan",
        TCA: "Turks And Caicos Islands",
        TUV: "Tuvalu",
        UGA: "Uganda",
        UKR: "Ukraine",
        ARE: "United Arab Emirates",
        GBR: "United Kingdom",
        URY: "Uruguay",
        UZB: "Uzbekistan",
        VUT: "Vanuatu",
        VAT: "Vatican City",
        VEN: "Venezuela",
        VNM: "Vietnam",
        WSM: "Western Samoa",
        YEM: "Yemen",
        ZMB: "Zambia",
        ZWE: "Zimbabwe"
    };
    // Dictionary to map Zephr US STATE values to DIGIOH US STATE values
    window.ZEPHR_US_STATES_VALUE_DICTIONARY = {
        AK: "Alaska",
        AL: "Alabama",
        AR: "Arkansas",
        AZ: "Arizona",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DC: "District of Columbia",
        DE: "Delaware",
        FL: "Florida",
        GA: "Georgia",
        HI: "Hawaii",
        IA: "Iowa",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        MA: "Massachusetts",
        MD: "Maryland",
        ME: "Maine",
        MI: "Michigan",
        MN: "Minnesota",
        MO: "Missouri",
        MS: "Mississippi",
        MT: "Montana",
        NE: "Nebraska",
        NH: "New Hampshire",
        NJ: "New Jersey",
        NM: "New Mexico",
        NV: "Nevada",
        NY: "New York",
        NC: "North Carolina",
        ND: "North Dakota",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PA: "Pennsylvania",
        RI: "Rhode Island",
        SC: "South Carolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TX: "Texas",
        UT: "Utah",
        VA: "Virginia",
        VT: "Vermont",
        WA: "Washington",
        WI: "Wisconsin",
        WV: "West Virginia",
        WY: "Wyoming",
        AB: "Alberta",
        AA: "Armed Forces Americas",
        AE: "Armed Forces Europe",
        AP: "Armed Forces Pacific AP",
        AS: "American Samoa",
        BC: "British Columbia",
        GU: "Guam",
        MB: "Manitoba",
        NB: "New Brunswick",
        NL: "Newfoundland and Labrador",
        NSW: "North South Wales",
        MP: "Northern Mariana Islands",
        NT: "Northwest Territories",
        NS: "Nova Scotia",
        NU: "Nunavut",
        ON: "Ontario",
        PE: "Prince Edward Island",
        PR: "Puerto Rico",
        QC: "Quebec",
        SK: "Saskatchewan",
        VI: "U.S. Virgin Islands",
        VIC: "Victoria",
        YT: "Yukon",
        NA: "Does Not Apply"
    };
})();

})();
//# sourceMappingURL=country-dictionary.js.map
